import { useCallback, useRef } from 'react';
export function useUiActions() {
  const popoverRef = useRef<HTMLDivElement>(null);
  const cookieSettingsRef = useRef<HTMLDialogElement>(null);
  const openSettings = useCallback(() => {
    popoverRef.current?.hidePopover();
    cookieSettingsRef.current?.showModal();
  }, []);
  const closeSettings = useCallback(() => {
    cookieSettingsRef.current?.close();
  }, []);
  const closePopover = useCallback(() => {
    popoverRef.current?.hidePopover();
  }, []);
  const openPopover = useCallback(() => {
    popoverRef.current?.showPopover();
  }, []);
  return {
    popoverRef,
    cookieSettingsRef,
    openSettings,
    closeSettings,
    closePopover,
    openPopover
  };
}